export type ProjectInvoice = { id: string; invoiceNumber: string; status: string; totalCents: number; balanceDueCents: number };
export type ProjectEstimate = { id: string; estimateNumber: string; title?: string | null; totalCents: number };
const currency = new Intl.NumberFormat("en-US", {style:"currency",currency:"USD"});
export const projectMoney = (cents: number) => currency.format(cents / 100);

export function ProjectDocuments({ invoices, estimates, invoiceCount = invoices.length, estimateCount = estimates.length, openAll }: {
  invoices: ProjectInvoice[]; estimates: ProjectEstimate[]; invoiceCount?: number; estimateCount?: number; openAll?: () => void;
}) {
  return <div className="project-documents">
    <section aria-label="Project invoices"><h3>Invoices <span>{invoiceCount}</span></h3>
      {invoices.length ? <ul>{invoices.map(invoice => <li key={invoice.id}>
        <div><a href={`/dashboard?invoice=${encodeURIComponent(invoice.id)}`}>Invoice #{invoice.invoiceNumber}</a><span className="project-document-status">{invoice.status.replaceAll("_", " ")}</span></div>
        <div><strong>{projectMoney(invoice.totalCents)}</strong><span>Balance {projectMoney(invoice.balanceDueCents)}</span></div>
      </li>)}</ul> : <p>No invoices linked.</p>}
      {invoiceCount > invoices.length && openAll && <button type="button" onClick={openAll}>View all {invoiceCount} invoices</button>}
    </section>
    <section aria-label="Sold estimates"><h3>Sold estimates <span>{estimateCount}</span></h3>
      {estimates.length ? <ul>{estimates.map(estimate => <li key={estimate.id}>
        <div><a href={`/dashboard?estimate=${encodeURIComponent(estimate.id)}`}>Estimate #{estimate.estimateNumber}</a><strong>{projectMoney(estimate.totalCents)}</strong></div>
        {estimate.title && <p>{estimate.title}</p>}
      </li>)}</ul> : <p>No sold estimates linked.</p>}
      {estimateCount > estimates.length && openAll && <button type="button" onClick={openAll}>View all {estimateCount} sold estimates</button>}
    </section>
  </div>;
}
